import { render, staticRenderFns } from "./groupStatement.vue?vue&type=template&id=7b108b38&"
import script from "./groupStatement.vue?vue&type=script&lang=js&"
export * from "./groupStatement.vue?vue&type=script&lang=js&"
import style0 from "./groupStatement.vue?vue&type=style&index=0&id=7b108b38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports